import {getCurrencySymbol} from '../../util/intl'
const LocaleCurrency = ({ISO,amount}) => `${getCurrencySymbol(ISO)}${amount} (${ISO})`

export default LocaleCurrency